export class Currency {
  public id: string;
  public code: string;
  public name: string;
  public isPrefix: boolean;
  public isEnabled: boolean;
}
